module.exports = __webpack_public_path__ + "img/kaufaufrechnung@2x.b977aa8.png";